import { render } from "./RequestBrochure.vue?vue&type=template&id=76247df2"
import script from "./RequestBrochure.vue?vue&type=script&lang=js"
export * from "./RequestBrochure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__